// Тексты обзора платформы, «Всех блогов» и «Онлайн» (ADM-UC-1…3).
export const ru = {
  admin: {
    blogs: {
      title: 'Все блоги',
      subtitle: 'Каждый блог платформы со счётчиками и объёмами — без содержимого блогов.',
      search: 'Поиск по названию и владельцу',
      sort: 'Сортировка',
      sorts: { name: 'По названию', changed: 'Недавно изменённые', created: 'Недавно созданные', posts: 'Больше постов', media: 'Больше медиа' },
      found: 'Найдено {shown} из {total}',
      empty: 'Блогов пока нет',
      nothingFound: 'Ничего не найдено',
      name: 'Блог',
      owners: 'Владельцы',
      members: 'Участники',
      posts: 'Посты',
      entities: 'Справочники / записи',
      media: 'Медиа',
      publications: 'Публикации',
      traffic: 'Трафик за {month}',
      created: 'Создан',
      lastChanged: 'Изменён',
    },
    online: {
      title: 'Онлайн',
      subtitle: 'Кто сейчас работает в приложении: открытые вкладки и устройства, открытые блоги. Список обновляется сам.',
      count: 'Онлайн: {n}',
      empty: 'Сейчас никого нет',
      user: 'Пользователь',
      admin: 'Администратор',
      connections: 'Вкладок',
      blogs: 'Открытые блоги',
      connectedAt: 'На связи с',
      lastSeenAt: 'Последний ответ',
    },
    overview: {
      title: 'Обзор системы',
      subtitle: 'Состояние платформы: сервер, база, хранилище, пользователи и блоги. Содержимое блогов здесь не показывается.',
      generatedAt: 'Снимок на {time}',
      refresh: 'Обновить',
      stats: {
        users: 'Пользователи',
        usersHint: 'админов {admins} · заблокировано {disabled} · в сети {active}',
        blogs: 'Блоги',
        allBlogs: 'Все блоги →',
        posts: 'Посты',
        entities: 'Записи справочников',
        entitiesHint: 'справочников {types}',
        media: 'Медиа',
        publications: 'Публикации',
        publicationsHint: 'запланировано {planned} · ждут {due} · вышло {published}',
        traffic: 'Трафик медиа за месяц',
      },
      server: {
        title: 'Сервер',
        version: 'Версия',
        uptime: 'Работает',
        startedAt: 'Запущен',
        instance: 'Инстанс',
        database: 'База данных',
        storage: 'Хранилище',
        coordination: 'Координация',
        mediaProcessor: 'Обработка медиа',
        mode: 'Режим',
        modeDemo: 'демо',
        modeTest: 'тестовый',
        modeNormal: 'рабочий',
        trafficLimit: 'Лимит трафика на блог',
        noLimit: 'без лимита',
        jobs: 'Фоновые задачи',
        noJobs: 'Ведёт этот инстанс (один процесс)',
        uptimeValue: '{d} дн {h} ч {m} мин',
      },
      database: {
        title: 'База данных',
        size: 'Размер',
        unknown: 'СУБД не сообщила',
        table: 'Таблица',
        rows: 'Строк',
      },
      storage: {
        title: 'Хранилище',
        accounted: 'Оригиналы в медиатеках',
        actual: 'Фактически в хранилище',
        actualHint: 'С превью и JPEG-копиями: {objects} файлов',
        measuring: 'Считаю…',
        measure: 'Посчитать заново',
      },
    },
  },
};

export const en: typeof ru = {
  admin: {
    blogs: {
      title: 'All blogs',
      subtitle: 'Every blog on the platform with counts and volumes — without blog content.',
      search: 'Search by name or owner',
      sort: 'Sort',
      sorts: { name: 'By name', changed: 'Recently changed', created: 'Recently created', posts: 'Most posts', media: 'Most media' },
      found: 'Found {shown} of {total}',
      empty: 'No blogs yet',
      nothingFound: 'Nothing found',
      name: 'Blog',
      owners: 'Owners',
      members: 'Members',
      posts: 'Posts',
      entities: 'References / records',
      media: 'Media',
      publications: 'Publications',
      traffic: 'Traffic in {month}',
      created: 'Created',
      lastChanged: 'Changed',
    },
    online: {
      title: 'Online',
      subtitle: 'Who is using the app right now: open tabs and devices, open blogs. The list updates by itself.',
      count: 'Online: {n}',
      empty: 'Nobody is online',
      user: 'User',
      admin: 'Administrator',
      connections: 'Tabs',
      blogs: 'Open blogs',
      connectedAt: 'Connected since',
      lastSeenAt: 'Last response',
    },
    overview: {
      title: 'System overview',
      subtitle: 'Platform state: server, database, storage, users and blogs. Blog content is not shown here.',
      generatedAt: 'Snapshot at {time}',
      refresh: 'Refresh',
      stats: {
        users: 'Users',
        usersHint: 'admins {admins} · disabled {disabled} · online {active}',
        blogs: 'Blogs',
        allBlogs: 'All blogs →',
        posts: 'Posts',
        entities: 'Reference records',
        entitiesHint: 'references {types}',
        media: 'Media',
        publications: 'Publications',
        publicationsHint: 'planned {planned} · due {due} · published {published}',
        traffic: 'Media traffic this month',
      },
      server: {
        title: 'Server',
        version: 'Version',
        uptime: 'Uptime',
        startedAt: 'Started',
        instance: 'Instance',
        database: 'Database',
        storage: 'Storage',
        coordination: 'Coordination',
        mediaProcessor: 'Media processing',
        mode: 'Mode',
        modeDemo: 'demo',
        modeTest: 'test',
        modeNormal: 'production',
        trafficLimit: 'Traffic limit per blog',
        noLimit: 'no limit',
        jobs: 'Background jobs',
        noJobs: 'Run by this instance (single process)',
        uptimeValue: '{d} d {h} h {m} min',
      },
      database: {
        title: 'Database',
        size: 'Size',
        unknown: 'Not reported by the database',
        table: 'Table',
        rows: 'Rows',
      },
      storage: {
        title: 'Storage',
        accounted: 'Originals in media libraries',
        actual: 'Actually in storage',
        actualHint: 'With previews and JPEG copies: {objects} files',
        measuring: 'Measuring…',
        measure: 'Measure again',
      },
    },
  },
};
